import { z } from "zod";

export namespace UserModels {
/** 
 * UserRoleSchema 
 * @type { enum }
 */
export const UserRoleSchema = z.enum(["USER", "STAFF", "ADMIN"]);
export type UserRole = z.infer<typeof UserRoleSchema>;
export const UserRole = UserRoleSchema.enum;

/** 
 * UserAccountResponseSchema 
 * @type { object }
 * @property { string } firstName  
 * @property { string } lastName  
 * @property { string } email  
 * @property { string } stripeCustomerId  
 * @property { string } subscriptionId  
 * @property { string } subscriptionStatus  
 * @property { string } subscriptionUntil  
 * @property { UserRole[] } roles  
 */
export const UserAccountResponseSchema = z.object({ firstName: z.string().nullable(), lastName: z.string().nullable(), email: z.email(), stripeCustomerId: z.string().nullish(), subscriptionId: z.string().nullish(), subscriptionStatus: z.string().nullish(), subscriptionUntil: z.iso.datetime({ offset: true }).nullish(), roles: z.array(UserRoleSchema) });
export type UserAccountResponse = z.infer<typeof UserAccountResponseSchema>;


/** 
 * CategoryPreferenceDtoSchema 
 * @type { object }
 * @property { boolean } enabled  
 */
export const CategoryPreferenceDtoSchema = z.object({ enabled: z.boolean() });
export type CategoryPreferenceDto = z.infer<typeof CategoryPreferenceDtoSchema>;


/** 
 * CategoryPreferencesResponseDtoSchema 
 * @type { object }
 * @property { CategoryPreferenceDto } live-show  
 * @property { CategoryPreferenceDto } endorsement  
 */
export const CategoryPreferencesResponseDtoSchema = z.object({ "live-show": CategoryPreferenceDtoSchema, endorsement: CategoryPreferenceDtoSchema });
export type CategoryPreferencesResponseDto = z.infer<typeof CategoryPreferencesResponseDtoSchema>;


/** 
 * EmailChannelPreferencesResponseDtoSchema 
 * @type { object }
 * @property { CategoryPreferencesResponseDto } categories  
 */
export const EmailChannelPreferencesResponseDtoSchema = z.object({ categories: CategoryPreferencesResponseDtoSchema });
export type EmailChannelPreferencesResponseDto = z.infer<typeof EmailChannelPreferencesResponseDtoSchema>;


/** 
 * ChannelsPreferencesResponseDtoSchema 
 * @type { object }
 * @property { EmailChannelPreferencesResponseDto } email  
 */
export const ChannelsPreferencesResponseDtoSchema = z.object({ email: EmailChannelPreferencesResponseDtoSchema });
export type ChannelsPreferencesResponseDto = z.infer<typeof ChannelsPreferencesResponseDtoSchema>;


/** 
 * NotificationPreferencesResponseDtoSchema 
 * @type { object }
 * @property { ChannelsPreferencesResponseDto } channels  
 */
export const NotificationPreferencesResponseDtoSchema = z.object({ channels: ChannelsPreferencesResponseDtoSchema });
export type NotificationPreferencesResponseDto = z.infer<typeof NotificationPreferencesResponseDtoSchema>;


/** 
 * CategoryPreferenceUpdateDtoSchema 
 * @type { object }
 * @property { boolean } enabled  
 */
export const CategoryPreferenceUpdateDtoSchema = z.object({ enabled: z.boolean().nullable() }).partial();
export type CategoryPreferenceUpdateDto = z.infer<typeof CategoryPreferenceUpdateDtoSchema>;


/** 
 * CategoriesUpdateDtoSchema 
 * @type { object }
 * @property { CategoryPreferenceUpdateDto } live-show  
 * @property { CategoryPreferenceUpdateDto } endorsement  
 */
export const CategoriesUpdateDtoSchema = z.object({ "live-show": CategoryPreferenceUpdateDtoSchema.nullable(), endorsement: CategoryPreferenceUpdateDtoSchema.nullable() }).partial();
export type CategoriesUpdateDto = z.infer<typeof CategoriesUpdateDtoSchema>;


/** 
 * EmailChannelUpdateDtoSchema 
 * @type { object }
 * @property { CategoriesUpdateDto } categories  
 */
export const EmailChannelUpdateDtoSchema = z.object({ categories: CategoriesUpdateDtoSchema.nullable() }).partial();
export type EmailChannelUpdateDto = z.infer<typeof EmailChannelUpdateDtoSchema>;


/** 
 * ChannelsUpdateDtoSchema 
 * @type { object }
 * @property { EmailChannelUpdateDto } email  
 */
export const ChannelsUpdateDtoSchema = z.object({ email: EmailChannelUpdateDtoSchema.nullable() }).partial();
export type ChannelsUpdateDto = z.infer<typeof ChannelsUpdateDtoSchema>;


/** 
 * UpdateNotificationPreferencesDtoSchema 
 * @type { object }
 * @property { ChannelsUpdateDto } channels  
 */
export const UpdateNotificationPreferencesDtoSchema = z.object({ channels: ChannelsUpdateDtoSchema.nullable() }).partial();
export type UpdateNotificationPreferencesDto = z.infer<typeof UpdateNotificationPreferencesDtoSchema>;


}
